// @flow

import React, { Component } from 'react';
import { Link } from 'react-router';
import { Collapse } from 'react-collapse';

/* eslint-disable no-nested-ternary, jsx-a11y/click-events-have-key-events */

const healthInsuranceRootId = 'health-insurance-root';
const lockRootScrollClass = 'lock-root-scroll';
const zendeskWidgetClass = '.zEWidget-launcher--active';
const hideZendeskWidgetClass = 'hide-zendesk-widget';

type Props = {
  sections: Array<Object>,
  currentSection?: string,
  currentSubsection?: string,
};

type State = {
  mobileMenuActive: boolean,
  mobile: boolean,
};

class LeftNav extends Component<Props, State> {
  static defaultProps = {
    currentSection: null,
    currentSubsection: null,
  };

  state = {
    mobileMenuActive: false,
    mobile: false,
  };

  componentDidMount() {
    this.handleMobile();
    window.addEventListener('resize', this.handleMobile);
    window.addEventListener('popstate', this.handleLeftNav);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleMobile);
    window.removeEventListener('popstate', this.handleLeftNav);
  }

  handleMobile = () => {
    if (window.innerWidth < 640 && !this.state.mobile) {
      this.setState({ mobile: true });
    } else if (window.innerWidth >= 640 && this.state.mobile) {
      this.setState({ mobileMenuActive: false, mobile: false });
    }
  };

  handleLeftNav = (e: SyntheticEvent<>) => {
    // Add 'position: fixed' to React root so that Left Nav mobile scrolling
    // only scrolls Navbar height
    if (this.state.mobile) {
      const rootSelector = document.getElementById(healthInsuranceRootId);
      const zendeskWidget = document.querySelector(zendeskWidgetClass);

      if (!rootSelector) return;

      if (e.type === 'popstate' || this.state.mobileMenuActive) {
        rootSelector.classList.remove(lockRootScrollClass);
        zendeskWidget?.classList.remove(hideZendeskWidgetClass);
        this.setState({
          mobileMenuActive: false,
        });
      } else {
        rootSelector.classList.add(lockRootScrollClass);
        zendeskWidget?.classList.add(hideZendeskWidgetClass);
        this.setState({
          mobileMenuActive: true,
        });
      }
    }
  };

  render() {
    const { sections, currentSection, currentSubsection } = this.props;

    // Same config found in Accordion/Panel component
    const springConfig = { stiffness: 250, damping: 30 };

    const sectionHeadings = sections.map(section => (
      <div key={section.id}>
        <li
          className={`section-heading-list-item ${
            currentSection === section.key && currentSubsection == null ? 'active-section-li' : ''
          }`}
          title={section.name}>
          <Link to={`guide/${section.key}`} title={section.name} className="section-link">
            {section.name}
          </Link>
          {section.pages && (
            <div
              className={
                currentSection === section.key || this.state.mobile
                  ? currentSubsection == null
                    ? 'arrow-icon icon-down-open-big icon-active'
                    : 'arrow-icon icon-down-open-big'
                  : 'arrow-icon icon-right-open-big'
              } />
          )}
          {/* Nested ternary allows for spacing consistency between bolded and unbolded text */}
        </li>
        {section.pages && section.pages.length > 0 && (
          <Collapse
            isOpened={currentSection === section.key || this.state.mobile}
            springConfig={springConfig}>
            {section.pages.map(page => (
              <li
                className={`subsection-heading-list-item ${
                  currentSubsection === page.key ? 'active-subsection-li' : ''
                }`}
                key={page.id}>
                <Link
                  to={`guide/${section.key}/${page.key}`}
                  key={page.id}
                  className={
                    currentSubsection === page.key ? 'subsection-link-active' : 'subsection-link'
                  }>
                  {page.name}
                  <br />
                </Link>
              </li>
            ))}
          </Collapse>
        )}
      </div>
    ));

    return (
      <div className="left-nav" onClick={this.handleLeftNav}>
        <div
          className={this.state.mobileMenuActive ? 'hamburger-menu-active' : 'hamburger-menu'}
          onClick={this.handleLeftNav}>
          <div className="hamburger-line" />
          <div className="hamburger-line" />
          <div className="hamburger-line" />
        </div>
        <div
          className={
            this.state.mobileMenuActive
              ? 'left-nav-parent-container-active'
              : 'left-nav-parent-container'
          }>
          {sectionHeadings}
        </div>
      </div>
    );
  }
}

export default LeftNav;
